(function () {
  'use strict';

  // Read the proxy URL from the section's data attribute or fall back to a global
  // The section schema setting is rendered in the Liquid template
  const sectionEl = document.querySelector('.tracking-page');
  const PROXY_URL = (sectionEl && sectionEl.dataset.proxyUrl) || window.__TRACKING_PROXY_URL || '';

  const STEP_ORDER = ['ordered', 'order_ready', 'in_transit', 'out_for_delivery', 'delivered'];

  // --- DOM refs ---
  const form = document.getElementById('tracking-form');
  const orderInput = document.getElementById('tracking-order-number');
  const emailInput = document.getElementById('tracking-email');
  const submitBtn = document.getElementById('tracking-submit');
  const submitText = document.querySelector('.tracking-form__submit-text');
  const submitLoading = document.querySelector('.tracking-form__submit-loading');
  const errorEl = document.getElementById('tracking-error');
  const resultsEl = document.getElementById('tracking-results');

  if (!form) return;

  // --- URL params auto-fill ---
  const params = new URLSearchParams(window.location.search);
  if (params.get('order')) orderInput.value = params.get('order');
  if (params.get('email')) emailInput.value = params.get('email');

  // Auto-track if both params are present
  if (params.get('order') && params.get('email')) {
    // Small delay to let the page render first
    setTimeout(function () { form.dispatchEvent(new Event('submit')); }, 300);
  }

  // --- Form submit ---
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var orderNumber = orderInput.value.trim();
    var email = emailInput.value.trim();

    if (!orderNumber || !email) return;

    // Strip leading # if present
    orderNumber = orderNumber.replace(/^#/, '');

    hideError();
    hideResults();
    setLoading(true);

    fetchTracking(orderNumber, email)
      .then(function (data) {
        setLoading(false);
        renderResults(data);
      })
      .catch(function (err) {
        setLoading(false);
        showError(err.message || 'Something went wrong. Please try again.');
      });
  });

  // --- API call ---
  function fetchTracking(orderNumber, email) {
    if (!PROXY_URL) {
      return Promise.reject(new Error('Tracking service is not configured. Please contact the store.'));
    }

    return fetch(PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ orderNumber: orderNumber, email: email }),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          throw new Error(data.error || 'Unable to track order.');
        }
        return data;
      });
    });
  }

  // --- Render results ---
  function renderResults(data) {
    // Order title
    document.getElementById('tracking-order-title').textContent = 'Order #' + data.orderNumber;

    // Progress bar
    renderProgress(data.step, data);

    // Status
    var statusText = 'Status: ' + (data.statusDescription || 'Processing');
    document.getElementById('tracking-status').textContent = statusText;

    // Delivery estimate / status message
    var deliveryEl = document.getElementById('tracking-delivery');
    if (data.actualDelivery) {
      deliveryEl.textContent = 'Delivered on ' + formatDate(data.actualDelivery);
    } else if (data.step === 'ordered' || data.step === 'processing') {
      deliveryEl.textContent = 'Your order is being prepared for shipment.';
    } else if (!data.events || data.events.length === 0) {
      deliveryEl.textContent = 'Waiting for carrier to update tracking information, please try again later.';
    } else if (data.estimatedDelivery) {
      deliveryEl.textContent = '';
    } else {
      deliveryEl.textContent = '';
    }

    // Estimated delivery date section
    var estDeliverySection = document.getElementById('tracking-est-delivery');
    if (estDeliverySection) {
      if (data.estimatedDelivery && !data.actualDelivery) {
        document.getElementById('tracking-est-delivery-date').textContent = formatDate(data.estimatedDelivery);
        estDeliverySection.style.display = '';
      } else {
        estDeliverySection.style.display = 'none';
      }
    }

    // Destination
    var destEl = document.getElementById('tracking-destination');
    var addrEl = document.getElementById('tracking-address');
    if (data.shipTo) {
      var parts = [data.shipTo.city, data.shipTo.state, data.shipTo.postalCode].filter(Boolean);
      addrEl.textContent = parts.join(', ');
      destEl.style.display = '';
    } else {
      destEl.style.display = 'none';
    }

    // Carrier
    var carrierSection = document.getElementById('tracking-carrier-section');
    if (data.carrier && data.trackingNumber) {
      document.getElementById('tracking-carrier-name').textContent = data.carrier.name;
      var trackLink = document.getElementById('tracking-link');
      trackLink.textContent = data.trackingNumber;
      trackLink.href = data.trackingUrl || '#';
      carrierSection.style.display = '';
    } else {
      carrierSection.style.display = 'none';
    }

    // Items
    var itemsSection = document.getElementById('tracking-items-section');
    var itemsList = document.getElementById('tracking-items-list');
    itemsList.innerHTML = '';
    if (data.items && data.items.length > 0) {
      data.items.forEach(function (item) {
        var div = document.createElement('div');
        div.className = 'tracking-info__item';

        if (item.imageUrl) {
          var img = document.createElement('img');
          img.className = 'tracking-info__item-image';
          img.src = item.imageUrl;
          img.alt = item.name || 'Product';
          img.loading = 'lazy';
          div.appendChild(img);
        }

        var nameSpan = document.createElement('span');
        nameSpan.className = 'tracking-info__item-name';
        nameSpan.textContent = item.name || 'Item';
        if (item.quantity > 1) {
          var qtySpan = document.createElement('span');
          qtySpan.className = 'tracking-info__item-qty';
          qtySpan.textContent = ' x' + item.quantity;
          nameSpan.appendChild(qtySpan);
        }
        div.appendChild(nameSpan);

        itemsList.appendChild(div);
      });
      itemsSection.style.display = '';
    } else {
      itemsSection.style.display = 'none';
    }

    // Timeline
    var timelineEl = document.getElementById('tracking-timeline');
    var eventsEl = document.getElementById('tracking-events');
    eventsEl.innerHTML = '';
    if (data.events && data.events.length > 0) {
      data.events.forEach(function (event) {
        var div = document.createElement('div');
        div.className = 'tracking-event';

        var dot = document.createElement('div');
        dot.className = 'tracking-event__dot';
        div.appendChild(dot);

        var time = document.createElement('div');
        time.className = 'tracking-event__time';
        time.textContent = formatDateTime(event.timestamp);
        div.appendChild(time);

        var desc = document.createElement('div');
        desc.className = 'tracking-event__description';
        desc.textContent = event.description;
        div.appendChild(desc);

        var locationParts = [event.city, event.state, event.country].filter(Boolean);
        if (locationParts.length > 0) {
          var loc = document.createElement('div');
          loc.className = 'tracking-event__location';
          loc.textContent = locationParts.join(', ');
          div.appendChild(loc);
        }

        eventsEl.appendChild(div);
      });
      timelineEl.style.display = '';
    } else {
      timelineEl.style.display = 'none';
    }

    resultsEl.style.display = '';
    resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // --- Progress bar ---
  function renderProgress(currentStep, data) {
    // Handle "processing" as "ordered"
    if (currentStep === 'processing') currentStep = 'ordered';

    var currentIndex = STEP_ORDER.indexOf(currentStep);
    if (currentIndex === -1) currentIndex = 0;

    STEP_ORDER.forEach(function (step, index) {
      var stepEl = document.querySelector('[data-step="' + step + '"]');
      if (!stepEl) return;

      stepEl.classList.remove('active', 'current');
      if (index < currentIndex) {
        stepEl.classList.add('active');
      } else if (index === currentIndex) {
        stepEl.classList.add('current');
      }
    });

    // Lines
    for (var i = 1; i <= 4; i++) {
      var lineEl = document.querySelector('[data-line="' + i + '"]');
      if (lineEl) {
        lineEl.classList.toggle('active', i <= currentIndex);
      }
    }

    // Dates on steps
    setStepDate('ordered', data.orderDate || data.shipDate);
    setStepDate('order_ready', data.shipDate);
    if (data.events && data.events.length > 0) {
      // Find the first "in transit" type event
      var transitEvent = data.events.find(function (e) {
        return e.statusCode === 'IT' || (e.description && e.description.toLowerCase().indexOf('transit') !== -1);
      });
      if (transitEvent) setStepDate('in_transit', transitEvent.timestamp);

      // Find "out for delivery"
      var outEvent = data.events.find(function (e) {
        return e.statusCode === 'AT' || (e.description && e.description.toLowerCase().indexOf('out for delivery') !== -1);
      });
      if (outEvent) setStepDate('out_for_delivery', outEvent.timestamp);
    }
    if (data.actualDelivery) setStepDate('delivered', data.actualDelivery);
  }

  function setStepDate(step, dateStr) {
    var el = document.querySelector('[data-date="' + step + '"]');
    if (el && dateStr) {
      el.textContent = formatShortDate(dateStr);
    } else if (el) {
      el.textContent = '';
    }
  }

  // --- Helpers ---
  function formatDate(dateStr) {
    if (!dateStr) return '';
    var d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  }

  function formatShortDate(dateStr) {
    if (!dateStr) return '';
    var d = new Date(dateStr);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }

  function formatDateTime(dateStr) {
    if (!dateStr) return '';
    var d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return d.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    }) + ' ' + d.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
    });
  }

  function setLoading(loading) {
    submitBtn.disabled = loading;
    submitText.style.display = loading ? 'none' : '';
    submitLoading.style.display = loading ? '' : 'none';
  }

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.style.display = '';
  }

  function hideError() {
    errorEl.style.display = 'none';
    errorEl.textContent = '';
  }

  function hideResults() {
    resultsEl.style.display = 'none';
  }
})();
